import useSWR from 'swr';
import { swrKeys } from '@shared/api/swr/keys';
import { mapBalanceDtoToEntity, type Balance } from '@entities/balance';

export const useBalance = () => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(swrKeys.accounting.balance(), {
    refreshInterval: (latest) => {
      const reserved = (latest as { reserved_balance?: number | string | null } | undefined)?.reserved_balance;
      if (reserved == null || reserved === '') return 0;
      const amount = Number(reserved);
      return Number.isFinite(amount) && amount > 0 ? 15000 : 0;
    },
  });

  const balance: Balance | null = data ? mapBalanceDtoToEntity(data) : null;

  return {
    balance,
    isLoading,
    isValidating,
    error,
    mutate,
  };
};
